import { useState } from "react";
import axiosInstance from "../../redux/helpers/axios";

const ACCENT_FROM = "#E11D74";
const ACCENT_TO = "#EF4444";
const inputClass =
  "mt-1 w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2";

// campaignId is passed in from the Segments page (the campaign the admin has selected there),
// since the page itself is scoped to one campaign at a time.
export default function CreateCampaignSegmentForm({
  campaignId,
  onCreated,
  onCancel,
}) {
  const [form, setForm] = useState({
    name: "",
    slug: "",
    description: "",
    slugTouched: false,
  });
  const [status, setStatus] = useState({ loading: false, error: null });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => {
      const next = { ...prev, [name]: value };
      if (name === "name" && !prev.slugTouched) {
        next.slug = value
          .toLowerCase()
          .trim()
          .replace(/[^a-z0-9]+/g, "-")
          .replace(/(^-|-$)/g, "");
      }
      return next;
    });
  };

  const handleSlugChange = (e) => {
    setForm((prev) => ({ ...prev, slug: e.target.value, slugTouched: true }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ loading: true, error: null });

    try {
      const res = await axiosInstance.post("/admin/campaign/segment/create", {
        name: form.name,
        slug: form.slug,
        description: form.description,
        campaignId,
      });
      onCreated(res.data.segment);
    } catch (err) {
      setStatus({
        loading: false,
        error:
          err?.response?.data?.error ||
          err?.response?.data?.msg ||
          "Failed to create segment",
      });
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-5">
      <div>
        <label className="block text-sm font-medium text-gray-700">Name</label>
        <input
          type="text"
          name="name"
          required
          value={form.name}
          onChange={handleChange}
          placeholder="Men's Fashion"
          className={inputClass}
          style={{ "--tw-ring-color": ACCENT_FROM }}
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700">Slug</label>
        <input
          type="text"
          name="slug"
          required
          value={form.slug}
          onChange={handleSlugChange}
          placeholder="mens-fashion"
          className={`${inputClass} font-mono`}
          style={{ "--tw-ring-color": ACCENT_FROM }}
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700">
          Description
        </label>
        <textarea
          name="description"
          rows={3}
          value={form.description}
          onChange={handleChange}
          className={inputClass}
          style={{ "--tw-ring-color": ACCENT_FROM }}
        />
      </div>

      {status.error && (
        <p className="text-sm text-red-600" role="alert">
          {status.error}
        </p>
      )}

      <div className="flex gap-3 pt-2">
        <button
          type="button"
          onClick={onCancel}
          className="flex-1 rounded-md border border-gray-300 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-50"
        >
          Cancel
        </button>
        <button
          type="submit"
          disabled={status.loading}
          className="flex-1 rounded-md py-2.5 text-sm font-medium text-white transition disabled:opacity-60"
          style={{
            background: `linear-gradient(90deg, ${ACCENT_FROM}, ${ACCENT_TO})`,
          }}
        >
          {status.loading ? "Creating..." : "Create segment"}
        </button>
      </div>
    </form>
  );
}
